import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AdminService } from '@app/services/admin/admin.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-welcome-info',
  templateUrl: './welcome-info.component.html'
})
export class WelcomeInfoComponent implements OnInit {
  text = 'Desktop';
  safeText: SafeHtml = 'Desktop';
  editmode = false;
  dirty = false;
  selectedscreentype = 0;
  screentypes: SelectItem[];

  constructor(private adminService: AdminService, private sanitizer: DomSanitizer) {
    this.screentypes = [
      { label: 'Desktop', value: 0 },
      { label: 'Mobil', value: 1 }
    ];
  }

  ngOnInit() {
    this.adminService.getFirstPageText(false).subscribe(text => {
      this.setText(text.text);
    });
  }

  setEditMode() {
    this.editmode = true;
  }

  setScreenType(evt: unknown) {
    this.setText(this.selectedscreentype === 0 ? 'Stor skärm' : 'Mobil');
    this.getFirstPageText(this.selectedscreentype === 0 ? false : true);
  }

  getFirstPageText(isMobile: boolean) {
    this.adminService.getFirstPageText(isMobile).subscribe(text => {
      this.setText(text.text);
    });
  }

  saveInfoText() {
    this.editmode = false;
    this.safeText = this.sanitizer.bypassSecurityTrustHtml(this.getDisplayText());
    var input = {
      Text: this.text,
      IsMobile: this.selectedscreentype === 0 ? false : true
    };
    this.adminService.EditFirstPageText(input).subscribe(_ => {
    });
  }

  replaceAll(str: string, find: string, replace: string): string {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  private setText(rawText: string): void {
    this.text = rawText || '';
    this.safeText = this.sanitizer.bypassSecurityTrustHtml(this.getDisplayText());
  }

  private getDisplayText(): string {
    return this.text
      .replace(/<\/p>\s*<p><br><\/p>\s*<p>/gi, '<br><br>')
      .replace(/<\/p>\s*<p>/gi, '<br>')
      .replace(/<p>/gi, '')
      .replace(/<\/p>/gi, '');
  }

}
